import React, {useLayoutEffect, useEffect, useState} from "react"
import styles from "../../styles/contract.module.css"
import {useOutletContext, useParams} from "react-router";
import {UploadTypes, handlers } from "../../hooks/use-uploader";
import {PdfPage} from "../../components/stateful/contract/signing/pdf-page";
import {PdfAttachments} from "../../components/stateful/contract/signing/pdf-attachments";
import DefaultLoader from "../../components/common/loaders/default-loader";
import {Container} from "react-bootstrap";
import UnitContractService from "../../services/unit-contract.service";
import ButtonLoader from "../../components/common/loaders/button-loader";
import {AttachmentTypes} from "../../utils/constants/contract";
import returnCurrentContractColor from "../../components/presentational/contract/return-current-contract-color";

const EditContract = () => {
    const {documentFile,usePdfFromParent,useAttachmentsFromParent,contractData,handleSignerListForSignature} = useOutletContext()
    const { file, initialize, pageIndex, isMultiPage, isFirstPage, isLastPage, currentPage, previousPage, nextPage, setDimensions, name, dimensions } = usePdfFromParent
    const { allPageAttachments,pageAttachments, reset: resetAttachments, update, remove, setPageIndex,addAtSpecificIndex } = useAttachmentsFromParent
    const {contractId} = useParams()
    const [signsPerSignerId,setSignsPerSignerId] = useState([])

    const {useHandleUpdateContractEdits} = UnitContractService()
    const {mutate:handleUpdateContractEdits,isLoading:isUpdateContractEditsLoading} = useHandleUpdateContractEdits()

    const initializePageAndAttachments = (pdfDetails) => {
        initialize(pdfDetails);
        const numberOfPages = pdfDetails.pages.length;
        resetAttachments(numberOfPages);
    };



    useEffect(()=>{
        if (!!allPageAttachments.find(el => el?.length > 0)){
            let signerIds = []
            for (let i = 0; i < allPageAttachments.length; i++) {
                let loopData = allPageAttachments[i]
                for (let j = 0; j < loopData.length; j++) {
                    if (loopData[j]?.type === AttachmentTypes.SIGNATURE){
                        signerIds.push(loopData[j].signerId)
                        // setSignsPerSignerId(prev => [...prev,loopData[j].signerId])
                    }
                }
            }
            handleSignerListForSignature(signerIds)
        }else{
            handleSignerListForSignature([])
        }
    },[allPageAttachments])
    useEffect(()=>{
        (async ()=>{
            initializePageAndAttachments(await handlers[UploadTypes.PDF](documentFile,true))
            if (contractData?.edits?.length > 0){
                for (let i = 0; i < contractData?.edits?.length; i++) {
                    let editData = contractData?.edits[i]
                    let currentSigner = contractData?.signers?.find(el=>el?._id === editData?.signerId)

                    // if (editData?.type === AttachmentTypes.SIGNATURE){
                    //     console.log("here")
                    //     handleSignerListForSignature(editData.signerId)
                    //     // setSignsPerSignerId(prev => [...prev,editData?.signerId])
                    // }

                    addAtSpecificIndex(editData?.pageNumber,{
                        id: editData?._id,
                        type:editData?.type,
                        x: editData?.xPosition,
                        y: editData?.yPosition,
                        width: 100,
                        editId:editData?._id,
                        signerId:editData?.signerId,
                        colorTheme:returnCurrentContractColor(currentSigner?.isApplicant ? "Applicant" : currentSigner?.isOwner ? "Owner" : "Co-Applicant"),
                        isEditable:false,
                        height: 40,
                        size: 14,
                        lineHeight: 1.4,
                        fontFamily: 'Times-Roman',
                        text: 'Initials',
                    })
                }

            }
        })()
    },[])

    useLayoutEffect(() => setPageIndex(pageIndex), [pageIndex, setPageIndex]);

    const confirmEdit = () => {
        let pageData = [];
        for (let i = 0; i < allPageAttachments.length; i++) {
            let loopData = allPageAttachments[i]
            for (let j = 0; j < loopData.length; j++) {
                pageData.push({
                    signerId: loopData[j].signerId,
                    type: loopData[j]?.type,
                    xPosition: loopData[j]?.x,
                    yPosition: loopData[j]?.y,
                    pageNumber: i,
                })
            }
        }
        handleUpdateContractEdits({pageData,contractId})
    }
    return (
        <>
            <section className={styles.edit__contract__wrapper}>
                <Container>
                    { !file ? (
                        <DefaultLoader/>
                    ) : (
                        <>
                            <div className={styles.pdf__wrapper}>
                                { currentPage && (
                                    <div className={"relative"}>
                                        <PdfPage
                                            dimensions={dimensions}
                                            updateDimensions={setDimensions}
                                            page={currentPage}
                                        />
                                        { dimensions && (
                                            <PdfAttachments
                                                pdfName={name}
                                                removeAttachment={remove}
                                                updateAttachment={update}
                                                pageDimensions={dimensions}
                                                attachments={pageAttachments}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </Container>
                {!!file && <div className={styles.bottom__action__buttons}>
                    {isMultiPage && !isFirstPage && !isUpdateContractEditsLoading && <button type={"button"} onClick={previousPage} className={styles.back}>Back</button>}
                    {isMultiPage && !isLastPage && <button type={"button"} onClick={nextPage} className={styles.next}>Next</button>}
                    {isLastPage && !isUpdateContractEditsLoading && <button type={"button"} className={styles.next} onClick={confirmEdit}>Confirm Edit</button>}
                    {isUpdateContractEditsLoading && <ButtonLoader/>}
                </div>}
            </section>
        </>
    )
}
export default EditContract
